'use client'

import type { ComponentProps } from 'react'
import { NotionRenderer } from 'react-notion-x'
import { cn } from '@cocoonspace/ui/lib/utils'
import Image from 'next/image'
import Link from 'next/link'
import 'react-notion-x/src/styles.css'

export const NotionPage = ({
	recordMap,
	className,
	...props
}: ComponentProps<typeof NotionRenderer>) => (
	<NotionRenderer
		className={cn(
			// Container
			'!w-full gap-0 !p-0',
			// Images
			'[&_img]:mx-auto',
			'[&_img]:max-w-md',
			'[&_img]:rounded-lg',
			// Callouts
			'[&_.notion-callout]:rounded-lg',
			'[&_.notion-callout]:border-none',
			'[&_.notion-callout]:bg-card',
			'[&_.notion-callout]:shadow-xs',
			'[&_.notion-red]:text-primary',
			// Quotes
			'[&_.notion-quote]:rounded-xl',
			'[&_.notion-quote]:border-none',
			'[&_.notion-quote]:bg-card',
			'[&_.notion-quote]:px-6',
			'[&_.notion-quote]:py-3',
			'[&_.notion-quote]:text-base',
			'[&_.notion-quote]:text-card-foreground',
			'[&_.notion-quote]:not-italic',
			'[&_.notion-quote]:shadow',
			// General
			'[&_*]:font-sans',
			className,
		)}
		components={{
			nextImage: Image,
			nextLink: Link,
		}}
		recordMap={recordMap}
		{...props}
	/>
)
